<script setup lang="ts">
  import TheContent from '~/components/content/TheContent';

  defineProps<{
    elem: TContent;
  }>();
</script>

<template>
  <TheContent
    v-for="(item, index) in elem.children"
    :key="index"
    :elem="item"
  />
</template>

<style lang="scss" scoped>
  .wp-block-lh-bb-recipe-note {
    @include fontH4AccentSmallText;

    width: 100%;
    background: #f3f5fc url('@/assets/images/step-hint-icon.svg') no-repeat 19px 24px;
    background-size: 29px auto;
    padding: 52px 24px 24px;
    margin: 24px auto 0;
    border-radius: 2px;

    &:not(:last-child) {
      margin-bottom: 24px;
    }

    @include tablet {
      @include fontH4AccentNormalText;

      padding: 16px 24px 16px 80px;
      background: #f3f5fc url('@/assets/images/step-hint-icon.svg') 25px center / 35px auto
        no-repeat;
    }

    @include print {
      font-family: $secondFont;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin: 16px auto 0;
      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }
</style>
